/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrincipioActivoDto } from '../../models/principio-activo-dto';

export interface PrincipiosActivosControllerListarPrincipiosActivos$Params {

/**
 * Término de búsqueda para filtrar por nombre del principio activo
 */
  busqueda?: string;

/**
 * Número máximo de resultados a devolver. Por defecto 50.
 */
  limit?: number;
}

export function principiosActivosControllerListarPrincipiosActivos(http: HttpClient, rootUrl: string, params?: PrincipiosActivosControllerListarPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrincipioActivoDto>>> {
  const rb = new RequestBuilder(rootUrl, principiosActivosControllerListarPrincipiosActivos.PATH, 'get');
  if (params) {
    rb.query('busqueda', params.busqueda, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PrincipioActivoDto>>;
    })
  );
}

principiosActivosControllerListarPrincipiosActivos.PATH = '/api/principios-activos/listar-principios-activos';
